export const TOGGLE_COLLAPSED_NAV = 'toggle_collapse_menu';
export const DRAWER_TYPE = 'drawer_type';
export const FIXED_DRAWER = 'fixed_drawer';
export const COLLAPSED_DRAWER = 'collapsible';
export const MINI_DRAWER = 'mini_drawer';
export const THEME_COLOR = 'theme_color';
export const DARK_THEME = 'dark_theme';
export const WINDOW_WIDTH = 'window-width';
export const SWITCH_LANGUAGE = 'switch-language';
export const CHANGE_DIRECTION = 'change-direction';

export const CHANGE_NAVIGATION_STYLE = 'change-navigation-style';
export const HORIZONTAL_NAVIGATION = 'horizontal_navigation';
export const VERTICAL_NAVIGATION = 'vertical_navigation';

export const HORIZONTAL_MENU_POSITION = 'horizontal_menu_position';
export const ABOVE_THE_HEADER = 'above_the_header';
export const INSIDE_THE_HEADER = 'inside_the_header';
export const BELOW_THE_HEADER = 'below_the_header';

//Contact Module const

export const FETCH_START = 'fetch_start';
export const FETCH_SUCCESS = 'fetch_success';
export const FETCH_ERROR = 'fetch_error';
export const SHOW_MESSAGE = 'show_message';
export const HIDE_MESSAGE = 'hide_message';

export const FETCH_ALL_CONTACT = 'fetch_all_contact';
export const FETCH_ALL_CONTACT_SUCCESS = 'fetch_all_contact_success';
export const ADD_FAVOURITE = 'add_favourite';
export const ON_CONTACT_SELECT = 'on_contact_select';
export const ON_ADD_CONTACT = 'on_add_contact';
export const ON_CONTACT_CLOSE = 'on_contact_close';
export const ON_FILTER_OPTION_SELECT = 'on_filter_option_select';
export const ON_SAVE_CONTACT = 'on_save_contact';
export const ON_DELETE_CONTACT = 'on_delete_contact';
export const ON_DELETE_SELECTED_CONTACT = 'on_delete_selected_contact';
export const FILTER_CONTACT = 'filter_contact';
export const GET_ALL_CONTACT = 'get_all_contact';
export const GET_UNSELECTED_ALL_CONTACT = 'get_unselected_all_contact';
export const ON_ALL_CONTACT_SELECT = 'on_all_contact_select';
export const UPDATE_SEARCH_USER = 'update_search_user';
export const ON_TOGGLE_DRAWER = 'on_toggle_drawer';
export const HANDLE_REQUEST_CLOSE = 'handle_request_close';
export const HIDE_CONTACT_LOADER = 'hide_contact_loader';

//Auth const
export const SIGNUP_USER = 'signup_user';
export const SIGNUP_USER_SUCCESS = 'signup_user_success';
export const SIGNIN_GOOGLE_USER = 'signin_google_user';
export const SIGNIN_GOOGLE_USER_SUCCESS = 'signin_google_user_success';
export const SIGNIN_FACEBOOK_USER = 'signin_facebook_user';
export const SIGNIN_FACEBOOK_USER_SUCCESS = 'signin_facebook_user_success';
export const SIGNIN_TWITTER_USER = 'signin_twitter_user';
export const SIGNIN_TWITTER_USER_SUCCESS = 'signin_twitter_user_success';
export const SIGNIN_GITHUB_USER = 'signin_github_user';
export const SIGNIN_GITHUB_USER_SUCCESS = 'signin_github_user_SUCCESS';
export const SIGNIN_USER = 'signin_user';
export const SIGNIN_USER_SUCCESS = 'signin_user_success';
export const SIGNOUT_USER = 'signout_user';
export const SIGNOUT_USER_BY_TIMEOUT = 'signout_user_by_timeout';
export const SIGNOUT_USER_SUCCESS = 'signout_user_success';
export const INIT_URL = 'init_url';
export const USER_DATA = 'user_data';
export const FETCH_AUTH_USER_DATA = 'fetch_user_data';
export const FETCH_AUTH_USER_DATA_SUCCESS = 'fetch_user_data_success';
export const FETCH_AUTH_USER_DATA_FAIL = 'fetch_user_data_fail';
export const USER_DATA_SUCCESS ="user_data_success";
export const USER_TOKEN_SET = 'user_token_set';
export const USER_REFRESH_TOKEN_SET = 'user_refresh_token_set';
export const CHANGE_PASSWORD = 'change_password';
export const CHANGE_PASSWORD_SUCCESS = 'change_password_success';
export const CHANGE_PASSWORD_FAIL = 'change_password_fail';
export const RESET_PASSWORD = 'reset_password';
export const RESET_PASSWORD_SET_INITIAL_VALUES = 'reset_password_set_initial_values';
export const RESET_PASSWORD_SUCCESS = 'reset_password_success';
export const RESET_PASSWORD_FAIL = 'reset_password_fail';
export const CONFIRM_EMAIL = 'confirm_email';
export const CONFIRM_EMAIL_SUCCESS = 'confirm_email_success';
export const CONFIRM_EMAIL_FAIL = 'confirm_email_fail';
export const CONFIRM_EMAIL_REINIT_STATE = 'confirm_email_reinit_state';
export const REGISTER_USER = 'register_user';
export const REGISTER_USER_SUCCESS = 'register_user_success';
export const REGISTER_USER_FAIL = 'register_user_fail';
export const ADD_NEW_USER_SELF_MANAGED = 'add_new_user_self_managed';
export const ADD_NEW_USER_SELF_MANAGED_SUCCESS = 'add_new_user_self_managed_success';
export const ADD_NEW_USER_SELF_MANAGED_FAIL = 'add_new_user_self_managed_fail';
export const FETCH_NEW_COMPANY = 'fetch_new_company';
export const FETCH_NEW_COMPANY_SUCCESS = 'fetch_new_company_success';
export const FETCH_NEW_COMPANY_FAIL = 'fetch_new_company_fail';
export const ADD_NEW_COMPANY = 'add_new_company';
export const ADD_NEW_COMPANY_SUCCESS = 'add_new_company_success';
export const ADD_NEW_COMPANY_FAIL = 'add_new_company_fail';
export const CONFIRM_COMPANY_REINIT_STATE = 'confirm_email_reinit_state';

//updating a non-persistent piece of state to allow for launching tours regardless of customer/user status
export const INITIATE_PRODUCT_TOUR_FOR_PAGE = 'initiate_product_tour_for_page';
export const INITIATE_PRODUCT_TOUR_FOR_PAGE_SUCCESS = 'initiate_product_tour_for_page_success';
export const INITIATE_PRODUCT_TOUR_FOR_PAGE_FAIL = 'initiate_product_tour_for_page_fail';

//User Management
export const FETCH_USERS = 'fetch_users';
export const FETCH_USERS_SUCCESS = 'fetch_users_success';
export const FETCH_USERS_FAIL = 'fetch_users_fail';
export const USERS_REINIT_STATE = 'users_reinit_state';
export const CREATE_NEW_USER = 'create_new_user';
export const CREATE_NEW_USER_SUCCESS = 'create_new_user_success';
export const CREATE_NEW_USER_FAIL = 'create_new_user_fail';
export const DELETE_USER = 'delete_user';
export const DELETE_USER_SUCCESS = 'delete_user_success';
export const DELETE_USER_FAIL = 'delete_user_fail';
export const SET_USER_IS_ACTIVE = 'set_user_is_active';
export const SET_USER_IS_ACTIVE_SUCCESS = 'set_user_is_active_success';
export const SET_USER_IS_ACTIVE_FAIL = 'set_user_is_active_fail';
export const SET_USER_NEEDS_PASSWORD_RESET = 'set_user_needs_password_reset';
export const SET_USER_NEEDS_PASSWORD_RESET_SUCCESS = 'set_user_needs_password_reset_success';
export const SET_USER_NEEDS_PASSWORD_RESET_FAIL = 'set_user_needs_password_reset_fail';
export const SET_USER_IS_APPROVED = 'set_user_is_approved';
export const SET_USER_IS_APPROVED_SUCCESS = 'set_user_is_approved_success';
export const SET_USER_IS_APPROVED_FAIL = 'set_user_is_approved_fail';
export const SET_USER_EMAIL_VERIFIED = 'set_user_email_verified';
export const SET_USER_EMAIL_VERIFIED_SUCCESS = 'set_user_email_verified_success';
export const SET_USER_EMAIL_VERIFIED_FAIL = 'set_user_email_verified_fail';



//Notification Messages
export const SUCCESS = 'success';
export const DEFAULT = 'default';
export const WARNING = 'warning';
export const INFO = 'info';
export const DANGER = 'danger';
export const CUSTOM = 'custom';

//Customer const
export const FETCH_CUSTOMERS = 'fetch_customers';
export const FETCH_CUSTOMERS_SUCCESS = 'fetch_customers_success';
export const FETCH_CUSTOMERS_FAIL = 'fetch_customers_fail';
export const SET_CUSTOMER_IN_VIEW = 'set_customer_in_view';
export const SET_STROMBOLI_OFF = 'set_stromboli_off';
export const SET_STROMBOLI_OFF_SUCCESS = 'set_stromboli_off_success';
export const SET_STROMBOLI_OFF_FAIL = 'set_stromboli_off_fail';
export const SET_STROMBOLI_ON = 'set_stromboli_on';
export const SET_STROMBOLI_ON_SUCCESS = 'set_stromboli_on_success';
export const SET_STROMBOLI_ON_FAIL = 'set_stromboli_on_fail';
export const CUSTOMER_REINIT_STATE = 'customer_reinit_state';
export const ADD_CUSTOMER = 'add_customer';
export const ADD_CUSTOMER_SUCCESS = 'add_customer_success';
export const ADD_CUSTOMER_FAIL = 'add_customer_fail';
//targets
export const FETCH_TARGETS = 'fetch_targets';
export const FETCH_TARGETS_SUCCESS = 'fetch_targets_success';
export const FETCH_TARGETS_FAIL = 'fetch_targets_fail';
export const FETCH_TARGET = 'fetch_target';
export const FETCH_TARGET_SUCCESS = 'fetch_target_success';
export const FETCH_TARGET_FAIL = 'fetch_target_fail';
//humans
export const FETCH_HUMANS = 'fetch_humans';
export const FETCH_HUMANS_SUCCESS = 'fetch_humans_success';
export const FETCH_HUMANS_FAIL = 'fetch_humans_fail';

//vectors
export const FETCH_VECTORS = 'fetch_vectors';
export const FETCH_VECTORS_SUCCESS = 'fetch_vectors_success';
export const FETCH_VECTORS_FAIL = 'fetch_vectors_fail';

//targets
export const SET_TARGET_SCOPE = 'set_target_scope';
export const SET_TARGET_SCOPE_SUCCESS = 'set_target_scope_success';
export const SET_TARGET_SCOPE_FAIL = 'set_target_scope_fail';

//campaigns
export const FETCH_CAMPAIGNS = 'fetch_campaigns';
export const FETCH_CAMPAIGNS_SUCCESS = 'fetch_campaigns_success';
export const FETCH_CAMPAIGNS_FAIL = 'fetch_campaigns_fail';

//attacks
export const FETCH_ATTACKS = 'fetch_attacks';
export const FETCH_ATTACKS_SUCCESS = 'fetch_attacks_success';
export const FETCH_ATTACKS_FAIL = 'fetch_attacks_fail';

export const FETCH_ATTACK = 'fetch_attack';
export const FETCH_ATTACK_SUCCESS = 'fetch_attack_success';
export const FETCH_ATTACK_FAIL = 'fetch_attack_fail';

export const FETCH_PERIMETER_ATTACKS_META = 'fetch_perimeter_attacks_meta';
export const FETCH_PERIMETER_ATTACKS_META_SUCCESS = 'fetch_perimeter_attacks_meta_success';
export const FETCH_PERIMETER_ATTACKS_META_FAIL = 'fetch_perimeter_attacks_meta_fail';

//requested and internal insider attacks
export const FETCH_INSIDER_ATTACK_OPTIONS = 'fetch_insider_attack_options';
export const FETCH_INSIDER_ATTACK_OPTIONS_SUCCESS = 'fetch_insider_attack_options_success';
export const FETCH_INSIDER_ATTACK_OPTIONS_FAIL = 'fetch_insider_attack_options_fail';

export const FETCH_REQUESTED_ATTACKS = 'fetch_requested_attacks';
export const FETCH_REQUESTED_ATTACKS_SUCCESS = 'fetch_requested_attacks_success';
export const FETCH_REQUESTED_ATTACKS_FAIL = 'fetch_requested_attacks_fail';

export const FETCH_INSIDER_ATTACK_DETAILS = 'fetch_insider_attack_details';
export const FETCH_INSIDER_ATTACK_DETAILS_SUCCESS = 'fetch_insider_attack_details_success';
export const FETCH_INSIDER_ATTACK_DETAILS_FAIL = 'fetch_insider_attack_details_fail';


export const POST_NEW_REQUESTED_ATTACK = 'post_new_requested_attack_options';
export const POST_NEW_REQUESTED_ATTACK_SUCCESS = 'post_new_requested_attack_success';
export const POST_NEW_REQUESTED_ATTACK_FAIL = 'post_new_requested_attack_fail';

//events
export const FETCH_EVENTS = 'fetch_events';
export const FETCH_EVENTS_SUCCESS = 'fetch_events_success';
export const FETCH_EVENTS_FAIL = 'fetch_events_fail';

//Misc
export const BOARD_ACTIVE_TAB = 'board_active_tab';
export const INSIDER_BOARD_ACTIVE_TAB = 'insider_board_active_tab';
export const CMMC_MODULE_ACTIVE_TAB = 'cmmc_module_active_tab';
export const NIST171_MODULE_ACTIVE_TAB = 'nist171_module_active_tab';


export const ON_SHOW_LOADER = 'on_show_loader';
export const ON_HIDE_LOADER = 'on_hide_loader';
//user management for customers
export const FETCH_USERS_FOR_CUSTOMER = 'fetch_users_for_customer';
export const FETCH_USERS_FOR_CUSTOMER_SUCCESS = 'fetch_users_for_customer_success';
export const FETCH_USERS_FOR_CUSTOMER_FAIL = 'fetch_users_for_customer_fail';

export const CREATE_USER_FOR_CUSTOMER = 'create_user_for_customer';
export const CREATE_USER_FOR_CUSTOMER_SUCCESS = 'create_user_for_customer_success';
export const CREATE_USER_FOR_CUSTOMER_FAIL = 'create_user_for_customer_fail';

export const DELETE_USER_FOR_CUSTOMER = 'delete_user_for_customer';
export const DELETE_USER_FOR_CUSTOMER_SUCCESS = 'delete_user_for_customer_success';
export const DELETE_USER_FOR_CUSTOMER_FAIL = 'delete_user_for_customer_fail';

export const DELETE_USER_FOR_CUSTOMER_INVITE = 'delete_user_for_customer_invite';
export const DELETE_USER_FOR_CUSTOMER_INVITE_SUCCESS = 'delete_user_for_customer_invite_success';
export const DELETE_USER_FOR_CUSTOMER_INVITE_FAIL = 'delete_user_for_customer_invite_fail';

// export const USER_INFO_STATE = 'user_info_state';
// export const SUBMIT_COMMENT = 'submit_comment';
// export const UPDATE_MESSAGE_VALUE = 'update_message_value';
// export const UPDATE_SEARCH_CHAT_USER = 'update_search_chat_user';
//
// //// Mail Module const
//
//
// export const ADD_LABEL = 'ADD_LABEL';
// export const GET_ALL_MAIL = 'get_all_mail';
// export const FETCH_ALL_MAIL = 'fetch_all_mail';
// export const FETCH_ALL_MAIL_SUCCESS = 'fetch_all_mail_success';
// export const GET_IMPORTANT_MAIL = 'get_important_mail';
// export const GET_NAV_FILTERS = 'get_nav_filters';
// export const GET_NAV_LABELS = 'get_nav_labels';
// export const GET_NAV_FOLDER = 'get_nav_folder';
// export const GET_READ_MAIL = 'get_read_mail';
// export const GET_STARRED_MAIL = 'get_starred_mail';
// export const GET_UNIMPORTANT_MAIL = 'get_unimportant_mail';
// export const GET_UNREAD_MAIL = 'get_unread_mail';
// export const GET_UNSELECTED_ALL_MAIL = 'get_unselected_all_mail';
// export const GET_UNSTARRED_MAIL = 'get_unstarred_mail';
// export const ON_ALL_MAIL_SELECT = 'on_all_mail_select';
// export const ON_FOLDER_MENU_ITEM_SELECT = 'on_folder_menu_item_select';
// export const ON_FOLDER_SELECT = 'on_folder_select';
// export const ON_IMPORTANT_SELECT = 'on_important_select';
// export const ON_LABEL_MENU_ITEM_SELECT = 'on_label_menu_item_select';
// export const GET_MARK_AS_START = 'get_mark_as_start';
// export const ON_LABEL_SELECT = 'on_label_select';
// export const ON_MAIL_CHECKED = 'on_mail_checked';
// export const ON_MAIL_SELECT = 'on_mail_select';
// export const ON_MAIL_SEND = 'on_mail_send';
// export const ON_OPTION_MENU_ITEM_SELECT = 'on_option_menu_item_select';
// export const ON_OPTION_MENU_SELECT = 'on_option_menu_select';
// export const ON_START_SELECT = 'on_start_select';
// export const SEARCH_MAIL = 'search_mail';
// export const ON_DELETE_MAIL = 'on_delete_mail';
// export const SET_CURRENT_MAIL_NULL = 'set_current_mail_null';
// export const ON_COMPOSE_MAIL = 'on_compose_mail';
//
// //// TO-DO Module const
//
// export const ON_SORTEND = 'on_sortend';
// export const FETCH_ALL_TODO = 'fetch_all_todo';
// export const FETCH_ALL_TODO_SUCCESS = 'fetch_all_todo-success';
// export const FETCH_ALL_TODO_CONVERSATION = 'fetch_all_todo_conversation';
// export const FETCH_ALL_TODO_CONVERSATION_SUCCESS = 'fetch_all_todo_conversation_success';
// export const SELECT_ALL_TODO = 'select_all_todo';
// export const GET_ALL_TODO = 'get_all_todo';
// export const GET_UNSELECTED_ALL_TODO = 'get_unselected_all_todo';
// export const GET_STARRED_TODO = 'get_starred_todo';
// export const GET_UNSTARRED_TODO = 'get_unstarred_todo';
// export const GET_IMPORTANT_TODO = 'get_important_todo';
// export const GET_UNIMPORTANT_TODO = 'get_unimportant_todo';
// export const ON_LABEL_UPDATE = 'on_label_update';
// export const ON_TODO_UPDATE = 'on_todo_update';
// export const ON_DELETE_TODO = 'on_delete_todo';
// export const SEARCH_TODO = 'search_todo';
// export const SHOW_TODOS = 'show_todos';
// export const GET_TODO_CONVERSATION = 'get_todo_conversation';
// export const ON_TODO_CHECKED = 'on_todo_checked';
// export const ON_TODO_ADD = 'on_todo_add';
// export const ON_TODO_SELECT = 'on_todo_select';
// export const SET_CURRENT_TODO_NULL = 'set_current_todo_null';
// export const REMOVE_LABEL = 'remove_label';
// export const UPDATE_SEARCH = 'update_search';

//module infrastructure
export const CUSTOMER_MODULE_ACTIVATE = 'customer_module_activate';
export const CUSTOMER_MODULE_ACTIVATE_SUCCESS = 'customer_module_activate_success';
export const CUSTOMER_MODULE_ACTIVATE_FAIL = 'customer_module_activate_fail';

export const CUSTOMER_MODULE_DEACTIVATE = 'customer_module_deactivate';
export const CUSTOMER_MODULE_DEACTIVATE_SUCCESS = 'customer_module_deactivate_success';
export const CUSTOMER_MODULE_DEACTIVATE_FAIL = 'customer_module_deactivate_fail';

//subscription infrastructure
export const CUSTOMER_SUBSCRIPTION_ACTIVATE = 'customer_subscription_activate';
export const CUSTOMER_SUBSCRIPTION_ACTIVATE_SUCCESS = 'customer_subscription_activate_success';
export const CUSTOMER_SUBSCRIPTION_ACTIVATE_FAIL = 'customer_subscription_activate_fail';

export const CUSTOMER_SUBSCRIPTION_DEACTIVATE = 'customer_subscription_deactivate';
export const CUSTOMER_SUBSCRIPTION_DEACTIVATE_SUCCESS = 'customer_subscription_deactivate_success';
export const CUSTOMER_SUBSCRIPTION_DEACTIVATE_FAIL = 'customer_subscription_deactivate_fail';

//compliance module
export const FETCH_COMPLIANCE_STANDARDS = 'fetch_compliance_standards';
export const FETCH_COMPLIANCE_STANDARDS_SUCCESS = 'fetch_compliance_standards_success';
export const FETCH_COMPLIANCE_STANDARDS_FAIL = "fetch_compliance_standards_fail"
export const FETCH_COMPLIANCE_ASSESSMENTS = 'fetch_compliance_assessments';
export const FETCH_COMPLIANCE_ASSESSMENTS_SUCCESS = 'fetch_compliance_assessments_success';
export const FETCH_COMPLIANCE_ASSESSMENTS_FAIL = "fetch_compliance_assessments_fail"
export const PUT_COMPLIANCE_ASSESSMENT = 'put_compliance_assessment';
export const PUT_COMPLIANCE_ASSESSMENT_SUCCESS = 'put_compliance_assessment_success';
export const PUT_COMPLIANCE_ASSESSMENT_FAIL = "put_compliance_assessment_fail"

//BREACHRISK
export const SET_ENTITY_IN_VIEW = 'set_entity_in_view';
export const BREACHRISK_REINIT_STATE = 'breachrisk_reinit_state';

export const FETCH_PORTFOLIO = 'fetch_portfolio';
export const FETCH_PORTFOLIO_SUCCESS = 'fetch_portfolio_success';
export const FETCH_PORTFOLIO_FAIL = 'fetch_portfolio_fail';

export const FETCH_CYCLE_REPORT = 'fetch_cycle_report';
export const FETCH_CYCLE_REPORT_SUCCESS = 'fetch_cycle_report_success';
export const FETCH_CYCLE_REPORT_FAIL = 'fetch_cycle_report_fail';

export const FETCH_CYCLE_DETAILS = 'fetch_cycle_details';
export const FETCH_CYCLE_DETAILS_SUCCESS = 'fetch_cycle_details_success';
export const FETCH_CYCLE_DETAILS_FAIL = 'fetch_cycle_details_fail';

export const FETCH_TARGET_DETAILS = 'fetch_target_details';
export const FETCH_TARGET_DETAILS_SUCCESS = 'fetch_target_details_success';
export const FETCH_TARGET_DETAILS_FAIL = 'fetch_target_details_fail';

export const FETCH_BR_BUSINESS_SHARES = 'fetch_br_business_shares';
export const FETCH_BR_BUSINESS_SHARES_SUCCESS = 'fetch_br_business_shares_success';
export const FETCH_BR_BUSINESS_SHARES_FAIL = 'fetch_br_business_shares_fail';

export const ADD_BR_BUSINESS_SHARE = 'add_br_business_shares';
export const ADD_BR_BUSINESS_SHARE_SUCCESS = 'add_br_business_shares_success';
export const ADD_BR_BUSINESS_SHARE_FAIL = 'add_br_business_shares_fail';

export const UPDATE_BR_BUSINESS_SHARE = 'update_br_business_shares';
export const UPDATE_BR_BUSINESS_SHARE_SUCCESS = 'update_br_business_shares_success';
export const UPDATE_BR_BUSINESS_SHARE_FAIL = 'update_br_business_shares_fail';

export const ADD_BR_PORTFOLIO_ENTITY = 'add_br_portfolio_entity';
export const ADD_BR_PORTFOLIO_ENTITY_SUCCESS = 'add_br_portfolio_entity_success';
export const ADD_BR_PORTFOLIO_ENTITY_FAIL = 'add_br_portfolio_entity_fail';

export const DELETE_BR_PORTFOLIO_ENTITY = 'delete_br_portfolio_entity';
export const DELETE_BR_PORTFOLIO_ENTITY_SUCCESS = 'delete_br_portfolio_entity_success';
export const DELETE_BR_PORTFOLIO_ENTITY_FAIL = 'delete_br_portfolio_entity_fail';

export const ADD_BR_PORTFOLIO_REPORT_REQUEST = 'add_br_portfolio_report_request_entity';
export const ADD_BR_PORTFOLIO_REPORT_REQUEST_SUCCESS = 'add_br_portfolio_report_request_entity_success';
export const ADD_BR_PORTFOLIO_REPORT_REQUEST_FAIL = 'add_br_portfolio_report_request_entity_fail';

export const UPDATE_BR_ATTACKS_AUTHORIZED = 'update_br_attacks_authorized';
export const UPDATE_BR_ATTACKS_AUTHORIZED_SUCCESS = 'update_br_attacks_authorized_success';
export const UPDATE_BR_ATTACKS_AUTHORIZED_FAIL = 'update_br_attacks_authorized_fail';

export const UPDATE_BR_SOCIAL_TESTS_AUTHORIZED = 'update_br_social_tests_authorized';
export const UPDATE_BR_SOCIAL_TESTS_AUTHORIZED_SUCCESS = 'update_br_social_tests_authorized_success';
export const UPDATE_BR_SOCIAL_TESTS_AUTHORIZED_FAIL = 'update_br_social_tests_authorized_fail';

export const ADD_BR_TARGETIP_PROVIDED = 'add_br_targetip_provided';
export const ADD_BR_TARGETIP_PROVIDED_SUCCESS = 'add_br_targetip_provided_success';
export const ADD_BR_TARGETIP_PROVIDED_FAIL = 'add_br_targetip_provided_fail';

export const ADD_BR_DOMAIN_PROVIDED = 'add_br_domain_provided';
export const ADD_BR_DOMAIN_PROVIDED_SUCCESS = 'add_br_domain_provided_success';
export const ADD_BR_DOMAIN_PROVIDED_FAIL = 'add_br_domain_provided_fail';

export const ADD_BR_SUBDOMAIN_PROVIDED = 'add_br_subdomain_provided';
export const ADD_BR_SUBDOMAIN_PROVIDED_SUCCESS = 'add_br_subdomain_provided_success';
export const ADD_BR_SUBDOMAIN_PROVIDED_FAIL = 'add_br_subdomain_provided_fail';

export const ADD_BR_IDENTITY_PROVIDED = 'add_br_identity_provided';
export const ADD_BR_IDENTITY_PROVIDED_SUCCESS = 'add_br_identity_provided_success';
export const ADD_BR_IDENTITY_PROVIDED_FAIL = 'add_br_identity_provided_fail';

export const UPDATE_BR_TARGETIP_PROVIDED = 'update_br_targetip_provided';
export const UPDATE_BR_TARGETIP_PROVIDED_SUCCESS = 'update_br_targetip_provided_success';
export const UPDATE_BR_TARGETIP_PROVIDED_FAIL = 'update_br_targetip_provided_fail';

export const UPDATE_BR_DOMAIN_PROVIDED = 'update_br_domain_provided';
export const UPDATE_BR_DOMAIN_PROVIDED_SUCCESS = 'update_br_domain_provided_success';
export const UPDATE_BR_DOMAIN_PROVIDED_FAIL = 'update_br_domain_provided_fail';

export const UPDATE_BR_SUBDOMAIN_PROVIDED = 'update_br_subdomain_provided';
export const UPDATE_BR_SUBDOMAIN_PROVIDED_SUCCESS = 'update_br_subdomain_provided_success';
export const UPDATE_BR_SUBDOMAIN_PROVIDED_FAIL = 'update_br_subdomain_provided_fail';

export const UPDATE_BR_IDENTITY_PROVIDED = 'update_br_identity_provided';
export const UPDATE_BR_IDENTITY_PROVIDED_SUCCESS = 'update_br_identity_provided_success';
export const UPDATE_BR_IDENTITY_PROVIDED_FAIL = 'update_br_identity_provided_fail';

export const ADD_BR_VALIDATION = 'add_br_validation';
export const ADD_BR_VALIDATION_SUCCESS = 'add_br_validation_success';
export const ADD_BR_VALIDATION_FAIL = 'add_br_validation_fail';

export const FETCH_CYCLE_TARGETS = 'fetch_cycle_targets';
export const FETCH_CYCLE_TARGETS_SUCCESS = 'fetch_cycle_targets_success';
export const FETCH_CYCLE_TARGETS_FAIL = 'fetch_cycle_targets_fail';

export const FETCH_CYCLE = 'fetch_cycle';
export const FETCH_CYCLE_SUCCESS = 'fetch_cycle_success';
export const FETCH_CYCLE_FAIL = 'fetch_cycle_fail';

export const FETCH_CYCLE_SOCIAL = 'fetch_cycle_social';
export const FETCH_CYCLE_SOCIAL_SUCCESS = 'fetch_cycle_social_success';
export const FETCH_CYCLE_SOCIAL_FAIL = 'fetch_cycle_social_fail';

export const FETCH_IDENTITY_DETAILS = 'fetch_identity_details';
export const FETCH_IDENTITY_DETAILS_SUCCESS = 'fetch_identity_details_success';
export const FETCH_IDENTITY_DETAILS_FAIL = 'fetch_identity_details_fail';

export const ADD_TAG = 'add_tag';
export const UPDATE_TAG = 'update_tag';
export const STOP_TAG_LOADER = 'stop_tag_loader';
// export const ADD_TAG_SUCCESS = 'add_tag_success';
// export const ADD_TAG_FAIL = 'add_tag_fail';

/*  jfd**********22.Jan.24.11:21*****
 *  TAG TYPE ACTIONS
 *   looks like different types of tags need to have specific success and fail actions.
 *  in order to properly update the local state when the data is returned.
 * IT looks like we can have one set of action types for each category of tags, e.g. settings, vectors on the
 * tech page, etc.
     ********************** `--===<>==<>==C>-< */
//group of tags that manipulate the tested vectors
export const ADD_TAG_SUCCESS_TESTED_VECTORS = 'add_tag_success_tested_vectors';
export const ADD_TAG_FAIL_TESTED_VECTORS = 'add_tag_fail_tested_vectors';

export const UPDATE_TAG_SUCCESS_TESTED_VECTORS = 'update_tag_success_tested_vectors';
export const UPDATE_TAG_FAIL_TESTED_VECTORS = 'update_tag_fail_tested_vectors';

export const ADD_TAG_ENTITY_SUCCESS = 'add_tag_entity_success';
export const ADD_TAG_ENTITY_FAIL = 'add_tag_entity_fail';

export const UPDATE_TAG_ENTITY_SUCCESS = 'update_tag_entity_success';
export const UPDATE_TAG_ENTITY_FAIL = 'update_tag_entity_fail';

//group of tags that are kept in the authuser.user part of the redux state
export const ADD_TAG_SUCCESS_AUTH_USER = 'add_tag_success_auth_user';
export const ADD_TAG_FAIL_AUTH_USER = 'add_tag_fail_auth_user';

export const UPDATE_TAG_SUCCESS_AUTH_USER = 'update_tag_success_auth_user';
export const UPDATE_TAG_FAIL_AUTH_USER = 'update_tag_fail_auth_user';


//group of tags that are kept in the user part of the redux state
export const ADD_TAG_SUCCESS_USER = 'add_tag_success_user';
export const ADD_TAG_FAIL_USER = 'add_tag_fail_user';

export const UPDATE_TAG_SUCCESS_USER = 'update_tag_success_user';
export const UPDATE_TAG_FAIL_USER = 'update_tag_fail_user';

export const ADD_USER_ROLE = 'add_user_role';
export const ADD_USER_ROLE_SUCCESS = 'add_user_role_success';
export const ADD_USER_ROLE_FAIL = 'add_user_role_fail';

export const DELETE_USER_ROLE = 'delete_user_role';
export const DELETE_USER_ROLE_SUCCESS = 'delete_user_role_success';
export const DELETE_USER_ROLE_FAIL = 'delete_user_role_fail';


//group of tags that are kept in customer part of redux state
export const ADD_TAG_CUSTOMER_SUCCESS = 'add_tag_customer_success';
export const ADD_TAG_CUSTOMER_FAIL = 'add_tag_customer_fail';

export const UPDATE_TAG_CUSTOMER_SUCCESS = 'update_tag_customer_success';
export const UPDATE_TAG_CUSTOMER_FAIL = 'update_tag_customer_fail';

//group of tags for social identity
export const ADD_TAG_IDENTITY_SUCCESS = 'add_tag_identity_success';
export const ADD_TAG_IDENTITY_FAIL = 'add_tag_identity_fail';

export const UPDATE_TAG_IDENTITY_SUCCESS = 'update_tag_identity_success';
export const UPDATE_TAG_IDENTITY_FAIL = 'update_tag_identity_fail';




// export const UPDATE_TAG_SUCCESS = 'update_tag_success';
// export const UPDATE_TAG_FAIL = 'update_tag_fail';



export const MASQUERADE = 'masquerade';
export const MASQUERADE_SUCCESS = 'masquerade_success';
export const MASQUERADE_FAIL = 'masquerade_fail';
export const MASQUERADE_ADMIN_USER_TOKEN_SET = 'masquerade_admin_user_token_set';
export const MASQUERADE_ADMIN_USER_REFRESH_TOKEN_SET = 'masquerade_admin_user_refresh_token_set';
export const MASQUERADE_QUIT = 'masquerade_quit';
export const MASQUERADE_QUIT_RESTORE_TOKENS = 'masquerade_quit_restore_tokens';

export const TOKENOFADMINDURINMASQUERADE_SET = 'tokenOfAdminDuringMasquerade_set';
export const REFRESHTOKENOFADMINDURINMASQUERADE_SET = 'refreshTokenOfAdminDuringMasquerade_set';

//REFRESHING THE TOKEN MANUALLY FROM WITHIN APP
export const MANUAL_TOKEN_REFRESH = 'manual_token_refresh';
export const MANUAL_TOKEN_REFRESH_SUCCESS = 'manual_token_refresh_success';
export const MANUAL_TOKEN_REFRESH_FAIL = 'manual_token_refresh_fail';

//MFA
export const MFA_REGISTER = 'mfa_register';
export const MFA_REGISTER_SUCCESS = 'mfa_register_success';
export const MFA_REGISTER_FAIL = 'mfa_register_fail';
export const MFA_VERIFY = 'mfa_verify';
export const MFA_VERIFY_SUCCESS = 'mfa_verify_success';
export const MFA_VERIFY_FAIL = 'mfa_verify_fail';
export const MFA_SESSION_TOKEN_SET = 'mfa_session_token_set';
export const MFA_LOGIN = 'mfa_login';
export const MFA_LOGIN_SUCCESS = 'mfa_login_success';
export const MFA_LOGIN_FAIL = 'mfa_login_fail';
export const MFA_REGISTER_DELETE = 'mfa_delete_register';
export const MFA_REGISTER_DELETE_SUCCESS = 'mfa_delete_register_success';
export const MFA_REGISTER_DELETE_FAIL = 'mfa_delete_register_fail';
export const MFA_RESET_REGISTRATION_FORM = 'mfa_reset_registration_form';
export const MFA_CLOSE_REGISTRATION_FORM = 'mfa_close_registration_form';
export const MFA_SET_LOGIN_META = 'mfa_set_login_meta';
export const MFA_SEND_ALT_CODE = 'mfa_send_alt_code';
export const MFA_SEND_ALT_CODE_SUCCESS = 'mfa_send_alt_code_success';
export const MFA_SEND_ALT_CODE_FAIL = 'mfa_send_alt_code_fail';


//Cloud Integrations
export const CLOUD_INTEGRATION_GET_OPTIONS = 'cloud_integrations_get_options';
export const CLOUD_INTEGRATION_GET_OPTIONS_SUCCESS = 'cloud_integrations_get_options_success';
export const CLOUD_INTEGRATION_GET_OPTIONS_FAIL = 'cloud_integrations_get_options_fail';

export const CLOUD_INTEGRATION_REGISTER = 'cloud_integrations_register';
export const CLOUD_INTEGRATION_REGISTER_SUCCESS = 'cloud_integrations_register_success';
export const CLOUD_INTEGRATION_REGISTER_FAIL = 'cloud_integrations_register_fail';

export const CLOUD_INTEGRATION_UNREGISTER = 'cloud_integrations_unregister';
export const CLOUD_INTEGRATION_UNREGISTER_SUCCESS = 'cloud_integrations_unregister_success';
export const CLOUD_INTEGRATION_UNREGISTER_FAIL = 'cloud_integrations_unregister_fail';

export const FETCH_CLOUD_INTEGRATION_DATA = 'fetch_cloud_integration_data';
export const FETCH_CLOUD_INTEGRATION_DATA_SUCCESS = 'fetch_cloud_integration_data_success';
export const FETCH_CLOUD_INTEGRATION_DATA_FAIL = 'fetch_cloud_integration_data_fail';

export const FETCH_CLOUD_INTEGRATION_FILES = 'fetch_cloud_integration_files';
export const FETCH_CLOUD_INTEGRATION_FILES_SUCCESS = 'fetch_cloud_integration_files_success';
export const FETCH_CLOUD_INTEGRATION_FILES_FAIL = 'fetch_cloud_integration_files_fail';

//action types for admin parts of state
export const FETCH_ADMIN_OKR = 'fetch_admin_okr';
export const FETCH_ADMIN_OKR_SUCCESS = 'fetch_admin_okr_success';
export const FETCH_ADMIN_OKR_FAIL = 'fetch_admin_okr_fail';

export const FETCH_SOCIAL_TEMPLATES = 'fetch_social_templates';
export const FETCH_SOCIAL_TEMPLATES_SUCCESS = 'fetch_social_templates_success';
export const FETCH_SOCIAL_TEMPLATES_FAIL = 'fetch_social_templates_fail';

export const ADD_SOCIAL_TEMPLATES = 'add_social_templates';
export const ADD_SOCIAL_TEMPLATES_SUCCESS = 'add_social_templates_success';
export const ADD_SOCIAL_TEMPLATES_FAIL = 'add_social_templates_fail';

export const UPDATE_SOCIAL_TEMPLATES = 'update_social_templates';
export const UPDATE_SOCIAL_TEMPLATES_SUCCESS = 'update_social_templates_success';
export const UPDATE_SOCIAL_TEMPLATES_FAIL = 'update_social_templates_fail';

export const SEND_SOCIAL_TEMPLATE_TEST = 'send_social_templates_test';
export const SEND_SOCIAL_TEMPLATE_TEST_SUCCESS = 'send_social_templates_test_success';
export const SEND_SOCIAL_TEMPLATE_TEST_FAIL = 'send_social_templates_test_fail';

//admin, subscription calls for subscriptoins we manage

export const ADD_BR_SUBSCRIPTION = 'add_br_subscription';
export const ADD_BR_SUBSCRIPTION_SUCCESS = 'add_br_subscription_success';
export const ADD_BR_SUBSCRIPTION_FAIL = 'add_br_subscription_fail';

export const UPDATE_BR_SUBSCRIPTION = 'update_br_subscription';
export const UPDATE_BR_SUBSCRIPTION_SUCCESS = 'update_br_subscription_success';
export const UPDATE_BR_SUBSCRIPTION_FAIL = 'update_br_subscription_fail';

//admin, call api for self-managed subscriptions recall

export const FETCH_MANAGE_BR_SUBSCRIPTION = 'fetch_manage_br_subscription';
export const FETCH_MANAGE_BR_SUBSCRIPTION_SUCCESS = 'fetch_manage_br_subscription_success';
export const FETCH_MANAGE_BR_SUBSCRIPTION_FAIL = 'fetch_manage_br_subscription_fail';

export const FETCH_MANAGE_SUB_TYPE = 'fetch_manage_sub_type';
export const FETCH_MANAGE_SUB_TYPE_SUCCESS = 'fetch_manage_sub_type_success';
export const FETCH_MANAGE_SUB_TYPE_FAIL = 'fetch_manage_sub_type_fail';

export const FETCH_BR_SUBSCRIPTION = 'fetch_br_subscription';
export const FETCH_BR_SUBSCRIPTION_SUCCESS = 'fetch_br_subscription_success';
export const FETCH_BR_SUBSCRIPTION_FAIL = 'fetch_br_subscription_fail';

//setting internal state flag to trigger reload of entity when onboarding progress item is completed
export const SET_UPDATE_ENTITY_ONBOARDING_PROGRESS = 'set_update_entity_onboarding_progress';
export const UNSET_UPDATE_ENTITY_ONBAORDING_PROGRESS = 'unset_update_entity_onboarding_progress'


//fetch testing result details for individual threat vector

export const FETCH_VECTOR_RESULTS = 'fetch_vector_results';
export const FETCH_VECTOR_RESULTS_SUCCESS = 'fetch_vector_results_success';
export const FETCH_VECTOR_RESULTS_FAIL = 'fetch_vector_results_fail';
/*  jfd**********22.Nov.28.12:06*****
 *   Sub portfolios
 * Add new sub portfolio
 * Delete sub portfolio
 * Add a brand new entity into a sub portfolio
 * Add an existing entity into a sub portfolio
 * Delete/remove an entity from a sub portfolio
 * Update/edit the name, description, etc of the sub portfolio
 * Move an entity from a sub portfolio into another sub portfolio
     ********************** `--===<>==<>==C>-< */
export const ADD_BR_SUBPORTFOLIO = 'add_br_subportfolio';
export const ADD_BR_SUBPORTFOLIO_SUCCESS = 'add_br_subportfolio_success';
export const ADD_BR_SUBPORTFOLIO_FAIL = 'add_br_subportfolio_fail';

export const DELETE_BR_SUBPORTFOLIO = 'delete_br_subportfolio';
export const DELETE_BR_SUBPORTFOLIO_SUCCESS = 'delete_br_subportfolio_success';
export const DELETE_BR_SUBPORTFOLIO_FAIL = 'delete_br_subportfolio_fail';

export const ADD_BR_EXISTING_ENTITY_TO_SUBPORTFOLIO = 'add_existing_entity_to_br_subportfolio';
export const ADD_BR_EXISTING_ENTITY_TO_SUBPORTFOLIO_SUCCESS = 'add_existing_entity_to_br_subportfolio_success';
export const ADD_BR_EXISTING_ENTITY_TO_SUBPORTFOLIO_FAIL = 'add_existing_entity_to_br_subportfolio_fail';

export const ADD_BR_NEW_ENTITY_TO_SUBPORTFOLIO = 'add_new_entity_to_br_subportfolio';
export const ADD_BR_NEW_ENTITY_TO_SUBPORTFOLIO_SUCCESS = 'add_new_entity_to_br_subportfolio_success';
export const ADD_BR_NEW_ENTITY_TO_SUBPORTFOLIO_FAIL = 'add_new_entity_to_br_subportfolio_fail';

export const DELETE_BR_ENTITY_FROM_SUBPORTFOLIO = 'delete_entity_from_br_subportfolio';
export const DELETE_BR_ENTITY_FROM_SUBPORTFOLIO_SUCCESS = 'delete_entity_from_br_subportfolio_success';
export const DELETE_BR_ENTITY_FROM_SUBPORTFOLIO_FAIL = 'delete_entity_from_br_subportfolio_fail';

export const UPDATE_BR_SUBPORTFOLIO = 'update_br_subportfolio';
export const UPDATE_BR_SUBPORTFOLIO_SUCCESS = 'update_br_subportfolio_success';
export const UPDATE_BR_SUBPORTFOLIO_FAIL = 'update_br_subportfolio_fail';

// export const MOVE_BR_NEW_ENTITY_TO_SUBPORTFOLIO = 'move_new_entity_to_br_subportfolio';
// export const MOVE_BR_NEW_ENTITY_TO_SUBPORTFOLIO_SUCCESS = 'move_new_entity_to_br_subportfolio_success';
// export const MOVE_BR_NEW_ENTITY_TO_SUBPORTFOLIO_FAIL = 'move_new_entity_to_br_subportfolio_fail';

export const SET_SUBPORTFOLIO_IN_VIEW = 'set_subportfolio_in_view';

export const VERIFY_PRIMARY_DOMAIN = 'verify_primary_domain';
export const VERIFY_PRIMARY_DOMAIN_SUCCESS = 'verify_primary_domain_success';
export const VERIFY_PRIMARY_DOMAIN_FAIL = 'verify_primary_domain_fail';

export const UPDATE_CUSTOMER_NAME = 'update_customer_name';
export const UPDATE_CUSTOMER_NAME_SUCCESS = 'update_customer_name_success';
export const UPDATE_CUSTOMER_NAME_FAIL = 'update_customer_name_fail';

export const UPDATE_ENTITY = 'update_entity';
export const UPDATE_ENTITY_SUCCESS = 'update_entity_success';
export const UPDATE_ENTITY_FAIL = 'update_entity_fail';

export const UPDATE_ENTITY_SETTINGS = 'update_entity_settings';
export const UPDATE_ENTITY_SETTINGS_SUCCESS = 'update_entity_settings_success';
export const UPDATE_ENTITY_SETTINGS_FAIL = 'update_entity_settings_fail';

export const UPDATE_ENTITY_NAME = 'update_entity_name';
export const UPDATE_ENTITY_NAME_SUCCESS = 'update_entity_name_success';
export const UPDATE_ENTITY_NAME_FAIL = 'update_entity_name_fail';

export const FETCH_ALL_ENTITIES = 'fetch_all_entities';
export const FETCH_ALL_ENTITIES_SUCCESS = 'fetch_all_entities_success';
export const FETCH_ALL_ENTITIES_FAIL = 'fetch_all_entities_fail';

export const UPDATE_PENTEST_SETTING_FOR_ENTITY = 'update_pentest_setting_for_entity';
export const UPDATE_PENTEST_SETTING_FOR_ENTITY_SUCCESS = 'update_pentest_setting_for_entity_success';
export const UPDATE_PENTEST_SETTING_FOR_ENTITY_FAIL = 'update_pentest_setting_for_entity_fail';

export const UPDATE_SOCIAL_TEST_SETTING_FOR_ENTITY = 'update_social_test_setting_for_entity';
export const UPDATE_SOCIAL_TEST_SETTING_FOR_ENTITY_SUCCESS = 'update_social_test_setting_for_entity_success';
export const UPDATE_SOCIAL_TEST_SETTING_FOR_ENTITY_FAIL = 'update_social_test_setting_for_entity_fail';